<template>
  <div class="mb-5">
    <div class="b-form__container_type_flex">
      <checkbox
        class="b-checkbox"
        v-model="form.isExtension"
        @change="changeExtensionState"
      >{{$t('CONTENT.assets.extension')}}</checkbox>
      <dynamic-icon class="ml-1" v-tooltip="$t('CONTENT.hints.extensionEvent')" icon="question"></dynamic-icon>
    </div>
    <transition name="fade">
      <div class="my-5 ml-6" v-if="form.isExtension">
        <div>
          <checkbox
            class="b-checkbox"
            v-model="extensionIsSure"
          >{{$t('CONTENT.assets.options_is_extended')}}</checkbox>
        </div>
        <div class="row mt-5 px-0">
          <div class="col-4">
            <div class="b-form__container">
              <label>{{$t('CONTENT.assets.option_month_count')}}:</label>
              <numeric
                class="b-numeric"
                controls
                :min="0"
                v-model="extensionMonthCount"
                :disabled="!form.isSure || isReadOnlyField"
                @keypress="changeNumericValue($event)"
                @change="onChangeExtensionMonthCount"
              ></numeric>
            </div>
          </div>
          <div class="col-4">
            <div class="b-form__container">
              <label>{{$t('CONTENT.date')}}:</label>
              <div class="is-manually">
                <div
                  v-if="isManuallyExtensionDate"
                  class="is-manually-mark"
                  :title="`${$t('CONTENT.isManuallyData')}`"
                ></div>
                <datepicker
                  class="b-datepicker"
                  v-model="extensionDate"
                  :disabled="!form.isSure || isReadOnlyField"
                  @change="onChangeEndDate"
                  :formatter="datepickerFormat"
                ></datepicker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import dateConverter from "@/utils/converters/date.converter";
import changeNumericValue from "../../../../../mixins/changeNumericValue";
import DateWithoutTimeAPI from "../../../../../api/DateWithoutTimeAPI";
import TerminationOption from "../../../../../models/contract/TerminationOption";
import datepickerFormat from '@/mixins/datepickerFormat.mixin';

export default {
  props: {
    assetComponent: {
      required: true,
      type: Object
    },
    form: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      extensionMonthCount: null,
      isManuallyExtensionDate: false,
      isReadOnlyField: false,
    };
  },
  mixins: [changeNumericValue, datepickerFormat],
  watch: {
    'form.isExtension'(val) {
      if(!val) {
        this.form.isSure = false;
        this.resetExtension();
      }
    },
  },
  computed: {
    extensionDate: {
      get() {
        if (this.form.date !== null) {
          return dateConverter.convertToDate(this.form.date);
        } else {
          return null;
        }
      },
      set(newVal) {
        if (newVal !== null) {
          this.form.date = dateConverter.convertToString(newVal);
        } else {
          this.form.date = null;
        }
      }
    },
    isDisabledExtension() {
      return !!this.assetComponent.isPermanent;
    },
    extensionIsSure: {
      get() {
        return this.form.isSure;
      },
      set(value) {
        this.form.isSure = value;

        if(!value) {
          this.resetExtension();
        }

        if (
          value &&
          (this.assetComponent.termination !== null &&
          this.assetComponent.termination.isSure)) {
          this.assetComponent.termination = TerminationOption.createNew();
        }
      }
    }
  },
  methods: {
    onChangeEndDate(newVal) {
      if (newVal == null) {
        this.isManuallyExtensionDate = false;
        this.extensionMonthCount = 0;
        return;
      }
      this.isManuallyExtensionDate = true;
      this.extensionMonthCount = 0;
      this.form.date = dateConverter.convertToString(newVal);
    },
    async onChangeExtensionMonthCount(newVal) {
      if (newVal !== 0) {
        try {
          this.isReadOnlyField = true;
          this.isManuallyExtensionDate = false;
          const currentAssetComponentEndDate = this.assetComponent.endDate;
          if (
            currentAssetComponentEndDate !== null &&
            currentAssetComponentEndDate !== ""
          ) {
            const convertedCurrentAssetComponentEndDate = encodeURIComponent(
              currentAssetComponentEndDate
            );
            const newDate = await new DateWithoutTimeAPI().addMonths(
              convertedCurrentAssetComponentEndDate,
              newVal
            );
            this.form.date = newDate;
            this.extensionDate = dateConverter.convertToDate(
              this.form.date
            );
          }
          this.isReadOnlyField = false;
        } catch (e) {
          this.isReadOnlyField = false;
          console.error(e);
        }
      }
    },
    changeExtensionState(e) {
      this.form.isExtension = e;
    },
    resetExtension() {
      this.extensionMonthCount = null;
      this.isManuallyExtensionDate = false;
      this.extensionDate = null;
      this.form.date = null;
    }
  }
};
</script>
